import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit"
import api from "../api/base"
import tokenSlice from "../state/token"
import applySlice from "../state/apply"
import apply2Slice from "../state/apply2"
import apply3Slice from "../state/apply3"
import customerDataReducer, {customerDataHandlerMiddleware} from "../state/customerdata"

export const store = configureStore({
  reducer: {
    customerData: customerDataReducer,
    [api.reducerPath]: api.reducer,
    token: tokenSlice,
    apply: applySlice,
    apply2: apply2Slice,
    apply3: apply3Slice,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    api.middleware,
    customerDataHandlerMiddleware
  ],
})


export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
